/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { gql } from '@apollo/client';

export const GET_LOOP_MANAGER = gql`
  query {
    getLoopManager @client {
      data
    }
  }
`;

export const GET_WORKER_MAP = gql`
  query {
    getWorkerMap @client {
      idMap
      reverseIdMap
    }
  }
`;

export const GET_LOCAL_DOCUMENT_PREVIEW = gql`
  query {
    getLocalDocumentPreview @client {
      data
    }
  }
`;

export const GET_LOG_MANAGER = gql`
  query {
    getLogManager @client {
      data
    }
  }
`;
